"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JettonWallet = void 0;
class JettonWallet {
    constructor(address) {
        this.address = address;
    }
    static createFromAddress(address) {
        return new JettonWallet(address);
    }
    async getBalance(provider) {
        let state = await provider.getState();
        if (state.state.type !== 'active') {
            return 0n;
        }
        let res = await provider.get('get_wallet_data', []);
        return res.stack.readBigNumber();
    }
    async getData(provider) {
        let res = await provider.get("get_wallet_data", []);
        const balance = res.stack.readBigNumber();
        const ownerAddress = res.stack.readAddress();
        const jettonMinterAddress = res.stack.readAddress();
        const jettonWalletCode = res.stack.readCell();
        return { balance, ownerAddress, jettonMinterAddress, jettonWalletCode };
    }
}
exports.JettonWallet = JettonWallet;
